import type { RootState } from '../../store';

const organizationQuery = (state: RootState) => state.organization.organization;

export { organizationQuery };
